import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Switch } from '@/components/ui/switch';

const OPTIONS = [
  { key: 'orders', label: 'New FarmBox orders', locked: false },
  { key: 'pickups', label: 'Pickup reminders', locked: false },
  { key: 'payments', label: 'Payment updates', locked: false },
  { key: 'messages', label: 'Messages from FarmBox', locked: false },
  { key: 'marketing', label: 'Seasonal tips & non-essential updates', locked: false },
  { key: 'critical', label: 'Critical order notifications (always on)', locked: true },
];

export default function FarmSettings() {
  const [prefs, setPrefs] = useState({ critical: true, orders: true, pickups: true, payments: true, messages: true, marketing: false });
  useEffect(() => { api.get('/farm/settings').then((r) => setPrefs({ ...prefs, ...r.data.notification_prefs })).catch(() => {}); /* eslint-disable-next-line */ }, []);

  const save = async (next) => { setPrefs(next); try { await api.put('/farm/settings', { notification_prefs: next }); toast.success('Settings saved'); } catch { toast.error('Failed'); } };

  return (
    <div data-testid="farm-settings" className="max-w-2xl">
      <p className="font-manrope text-dark/60 mb-6">Choose which notifications you'd like to receive. Critical order notifications stay on to keep supply reliable.</p>
      <div className="bg-white rounded-2xl border border-forest/10 divide-y divide-forest/10">
        {OPTIONS.map((o) => (
          <div key={o.key} className="flex items-center justify-between p-5" data-testid={`setting-${o.key}`}>
            <span className="font-manrope text-dark">{o.label}</span>
            <Switch checked={!!prefs[o.key]} disabled={o.locked} onCheckedChange={(v) => !o.locked && save({ ...prefs, [o.key]: v })} />
          </div>
        ))}
      </div>
    </div>
  );
}
